import { react2angular } from 'react2angular';

import AnsweringServiceInfo from './admin_answering/AnsweringServiceInfo/AnsweringServiceInfo.tsx';
import AdminAnsweringTabs from './admin_answering/AdminAnsweringTabs/AdminAnsweringTabs.tsx';
import OfferQueue from './OfferQueue';
import ExclusivesQueue from './ExclusivesQueue';

angular
  .module('bb.admin', ['ngRoute', 'bb.util'])
  .component(
    'bbAnsweringServiceInfo',
    react2angular(AnsweringServiceInfo, ['answeringOrg']),
  )
  .component(
    'bbAdminAnsweringTabs',
    react2angular(AdminAnsweringTabs, ['onTabChange', 'activeTab']),
  )
  .component(
    'bbOfferQueue',
    react2angular(OfferQueue, [
      'listings',
      'openContactDrawer',
      'handleSort',
      'sortBy',
      'sortDirection',
      'reload',
      'setOfferListing',
      'selectedListing',
      'getBoardName',
    ]),
  )
  .component(
    'exclusivesQueue',
    react2angular(
      ExclusivesQueue,
      ['auth', 'locations', 'setExclusivesCount'],
      ['$rootScope', '$window'],
    ),
  );

require('./admin.routes');

require('./admin_dashboard.component');
require('./admin_answering/admin_answering.component');
require('./admin_answering/AnsweringTimeSettings/answering_time_settings.component');

require('./admin.service');
